window.addEventListener("DOMContentLoaded", function() {
  initNav();
});

function initNav() {
  const siteNavList = document.querySelector('.site-nav__list');
  const subMenusItems = document.querySelectorAll('.menu-item-has-children');
  const siteNavToggle = document.querySelector('.site-nav__toggle');
  let alreadyOpened = false;

  /**********************************************************************
   ******* REPLACE SUBMENUS PARENT LINKS BY BUTTONS AND ADD ARIA  *******
  *********************************************************************/

  subMenusItems.forEach(item => {
    const link = item.querySelector('a');
    if (link.href.endsWith('#')) {
      const linkCopy = link.cloneNode(true);
      const linkCopyContent = linkCopy.innerHTML;
      const newLink = document.createElement('button');
      newLink.innerHTML = linkCopyContent;
      newLink.classList.add('site-nav__submenu-btn');
      newLink.setAttribute( 'aria-expanded', false );
      const rand = Math.random().toString(16).substr(2, 8);
      const randomId = 'sub-menu-'+ rand;
      newLink.setAttribute( 'aria-controls', randomId );
      item.replaceChild(newLink, link);
      const subMenu = item.querySelector('.sub-menu');
      subMenu.id = randomId;
    };
  });


  /***********************************
   ******* TABINDEX MANAGEMENT *******
  **********************************/

  function toggleTabIndexFromAllMobileNavLinks() {
    // if nav toggle is not visible => return
    if (window.getComputedStyle(siteNavToggle).display === "none") {
      const firstLevelMobileNavLinks = document.querySelectorAll('.site-nav__list > li > a, .site-nav__list > li > button');
      firstLevelMobileNavLinks.forEach(link => {
        link.tabIndex = "0";
      });
    } else {
      const mobileNavLinks = document.querySelectorAll('.site-nav__list a, .site-nav__list button');
      mobileNavLinks.forEach(link => {
        link.tabIndex = "-1";
      });
    }
  }

  toggleTabIndexFromAllMobileNavLinks();

  function toggleTabIndexFromMobileNavLinks() {
    const firstLevelMobileNavLinks = document.querySelectorAll('.site-nav__list > li > a, .site-nav__list button');
    let tabIndex = "-1";
    if (siteNavToggle.getAttribute('aria-expanded') === 'false') {
      tabIndex = "-1";
    } else {
      tabIndex = "0";
    }
    firstLevelMobileNavLinks.forEach(link => {
      link.tabIndex = tabIndex;
    });
  }

  function trapFocusInMobileNav(e) {
    const keycodeTab = 9;
    let isTabPressed = (e.key === 'Tab' || e.keyCode === keycodeTab);

    if (!isTabPressed) {
      return;
    }

    const focusableEls = document.querySelectorAll('.site-nav__toggle, .site-nav__list > li > a, .site-nav__list a[tabindex="0"], .site-nav__list button');
    const firstFocusableEl = focusableEls[0];
    const lastFocusableEl = focusableEls[focusableEls.length - 1];

    if (e.shiftKey) /* shift + tab */ {
      if (document.activeElement === firstFocusableEl) {
        lastFocusableEl.focus();
        e.preventDefault();
      }
    } else /* tab */ {
      if (document.activeElement === lastFocusableEl) {
        firstFocusableEl.focus();
        e.preventDefault();
      }
    }
  }

  function removeTabIndexFromAllSubMenusLinks() {
    const subMenusLinks = document.querySelectorAll('.menu-item-has-children .sub-menu a, .menu-item-has-children .sub-menu button');
    subMenusLinks.forEach(link => {
      link.tabIndex = "-1";
    });
  }

  removeTabIndexFromAllSubMenusLinks();

  function addTabIndexFromSpecificSubMenuLinks(menu) {
    const activeMenu = menu.querySelectorAll('a');
    activeMenu.forEach(link => {
      link.tabIndex = "0";
    });
  }

  function removeTabIndexFromSpecificSubMenuLinks(menu) {
    const activeMenu = menu.querySelectorAll('a');
    activeMenu.forEach(link => {
      link.tabIndex = "-1";
    });
  }


  /***********************************************
   ******* ACTIONS WHEN SUBMENU IS CLICKED *******
  **********************************************/

  const subMenusButtons = document.querySelectorAll('.site-nav__submenu-btn');

  document.addEventListener('click', function(e) {
    if (e.target.classList.contains('site-nav__submenu-btn')) {
      handleSubMenuButtons(e);
    } else {
      subMenusButtons.forEach(btn => {
        const subMenuList = btn.nextElementSibling;
        closeSubMenu(btn, subMenuList);
      });
    }
  });

  function handleSubMenuButtons(e) {
    subMenusButtons.forEach(btn => {
      const subMenuList = btn.nextElementSibling;
      const target = e.target;
      if (btn === target) {
        if (btn.getAttribute('aria-expanded') === 'false') {
          openSubMenu(btn, subMenuList);
        } else {
          closeSubMenu(btn, subMenuList);
        }
      } else {
        closeSubMenu(btn, subMenuList);
      }
    });
  }

  function openSubMenu(btn, menu) {
    btn.setAttribute('aria-expanded', 'true');
    menu.parentNode.classList.add('list-item-opened');
    menu.classList.add('opened');
    addTabIndexFromSpecificSubMenuLinks(menu);
  }

  function closeSubMenu(btn, menu) {
    btn.setAttribute('aria-expanded', 'false');
    menu.parentNode.classList.remove('list-item-opened');
    menu.classList.remove('opened');
    removeTabIndexFromSpecificSubMenuLinks(menu);
  }


  /**************************
   ******* MOBILE NAV *******
  *************************/

  siteNavToggle.addEventListener('click', function() {
    if (siteNavToggle.getAttribute('aria-expanded') === 'false') {
      openSiteNav();
    } else {
      closeSiteNav();
    }
    toggleTabIndexFromMobileNavLinks();
    checkIfNavShouldBeHidden();
  })

  function openSiteNav() {
    if (!alreadyOpened) {
      siteNavList.style.transition = 'transform 350ms ease-out, opacity 350ms ease-out';
      alreadyOpened = true;
    }
    siteNavToggle.setAttribute('aria-expanded', 'true');
    document.body.setAttribute('data-nav-opened', 'true');
    document.addEventListener('keydown', trapFocusInMobileNav);
  }

  function closeSiteNav() {
    siteNavToggle.setAttribute('aria-expanded', 'false');
    document.body.removeAttribute('data-nav-opened');
    document.removeEventListener('keydown', trapFocusInMobileNav);
  }

  function checkIfNavShouldBeHidden() {
    const width = window.innerWidth;
    if (width >= 900) {
      siteNavList.setAttribute('aria-hidden', 'false');
    } else {
      if (!document.body.hasAttribute('data-nav-opened')) {
        siteNavList.setAttribute('aria-hidden', 'true');
      } else {
        siteNavList.setAttribute('aria-hidden', 'false');
      }
    }
  }

  checkIfNavShouldBeHidden();


  /*************************************
   ******* RESIZE WINDOW WATCHER *******
  **************************************/

  let windowResizeTimer;
  window.onresize = function() {
    clearTimeout(windowResizeTimer);
    windowResizeTimer = setTimeout(function() {
      toggleTabIndexFromAllMobileNavLinks();
      checkIfNavShouldBeHidden();
    }, 150);
  };


}
